import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf,
  listOfNotNull1v4ggfackvuny as listOfNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  sortedWith2csnbbb21k0lg as sortedWith,
  plus310ted5e4i90h as plus,
  first58ocm7j58k3q as first,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  copyToArray2j022khrow2yi as copyToArray,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance,
  OBJECT_getInstancerq52wx6ymebx as OBJECT_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { JsonNames3i9ju5gyx18ko as JsonNames } from '../../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/JsonAnnotations.mjs';
import { buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { LazySerialDescriptor3enjj1xzeog28 as LazySerialDescriptor } from './SerializationHelpers.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  default1jaun537xukbl as default_0,
  DefaultDecoder2rhqlc390svhj as DefaultDecoder,
  KSerializerWithDefault3c244bl47fg5p as KSerializerWithDefault,
} from './Defaults.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var OptionClass;
function Option() {
  if (OptionClass === VOID) {
    class $ {
      constructor(serializer, baseName, alternativeNames, annotations, priority, isInstance) {
        var tmp;
        if (alternativeNames === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = alternativeNames;
        }
        alternativeNames = tmp;
        var tmp_0;
        if (annotations === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp_0 = emptyList();
        } else {
          tmp_0 = annotations;
        }
        annotations = tmp_0;
        this.serializer_1 = serializer;
        this.baseName_1 = baseName;
        this.alternativeNames_1 = alternativeNames;
        this.annotations_1 = annotations;
        this.priority_1 = priority;
        this.isInstance_1 = isInstance;
      }
    }
    initMetadataForClass($, 'Option');
    OptionClass = $;
  }
  return OptionClass;
}
function getIndex($this, item) {
  var tmp0 = $this.get_options_jecmyz_k$();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index = 0;
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item_0 = _iterator__ex2g4s.next_20eer_k$();
      if (item_0.isInstance_1(item)) {
        tmp$ret$0 = index;
        break $l$block;
      }
      index = index + 1 | 0;
    }
    tmp$ret$0 = -1;
  }
  // Inline function 'kotlin.also' call
  var this_0 = tmp$ret$0;
  if (this_0 === -1) {
    var tmp = $this.descriptor_1.get_serialName_u2rqhk_k$();
    var tmp_0 = toString(getKClassFromExpression(item));
    var tmp_1 = $this.get_options_jecmyz_k$();
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('No serializer inside ' + tmp + ' found for ' + tmp_0 + '; options are ' + joinToString(tmp_1, VOID, VOID, VOID, VOID, VOID, MySealedClassSerializer$getIndex$lambda));
  }
  return this_0;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function MySealedClassSerializer$options$delegate$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.priority_1;
  var tmp$ret$2 = a.priority_1;
  return compareValues(tmp, tmp$ret$2);
}
function MySealedClassSerializer$_get_options_$ref_rhb6tc() {
  return constructCallableReference((p0) => p0.get_options_jecmyz_k$(), 1, 0, 142);
}
function MySealedClassSerializer$getIndex$lambda(it) {
  return it.serializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
}
var MySealedClassSerializerClass;
function MySealedClassSerializer() {
  if (MySealedClassSerializerClass === VOID) {
    class $ {
      constructor(serialName, options, annotations) {
        var tmp;
        if (annotations === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = annotations;
        }
        annotations = tmp;
        this.annotations_1 = annotations;
        var tmp_0 = this;
        tmp_0.options$delegate_1 = lazy(() => {
          // Inline function 'kotlin.collections.sortedByDescending' call
          var this_0 = options();
          // Inline function 'kotlin.comparisons.compareByDescending' call
          var tmp = MySealedClassSerializer$options$delegate$lambda$lambda;
          var tmp$ret$2 = new (sam$kotlin_Comparator$0())(tmp);
          return sortedWith(this_0, tmp$ret$2);
        });
        var tmp_1 = this;
        tmp_1.nameToIndex$delegate_1 = lazy(() => {
          // Inline function 'kotlin.collections.flatMapIndexed' call
          var tmp0 = this.get_options_jecmyz_k$();
          // Inline function 'kotlin.collections.flatMapIndexedTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var index = 0;
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            var _unary__edvuaz = index;
            index = _unary__edvuaz + 1 | 0;
            var index_0 = checkIndexOverflow(_unary__edvuaz);
            // Inline function 'kotlin.collections.map' call
            var this_0 = plus(listOf([element.baseName_1, element.serializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$()]), element.alternativeNames_1);
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s_0 = this_0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
              var item = _iterator__ex2g4s_0.next_20eer_k$();
              var tmp$ret$8 = to(item, index_0);
              destination_0.add_utx5q5_k$(tmp$ret$8);
            }
            var list = destination_0;
            addAll(destination, list);
          }
          // Inline function 'kotlin.collections.associate' call
          var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
          // Inline function 'kotlin.collections.associateTo' call
          var destination_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
          var _iterator__ex2g4s_1 = destination.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
            var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
            // Inline function 'kotlin.collections.plusAssign' call
            destination_1.put_4fpzoq_k$(element_0.first_1, element_0.second_1);
          }
          return destination_1;
        });
        var tmp_2 = this;
        var tmp_3 = CLASS_getInstance();
        tmp_2.descriptor_1 = new (LazySerialDescriptor())(serialName, tmp_3, VOID, () => buildClassSerialDescriptor(serialName, [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.annotations_1 = this.annotations_1;
          var iterator = this.get_options_jecmyz_k$().iterator_jk1svi_k$();
          var index = 0;
          while (iterator.hasNext_bitz1p_k$()) {
            var index_0 = index;
            index = index + 1 | 0;
            var s = iterator.next_20eer_k$();
            var tmp0_elementName = s.baseName_1;
            var tmp1_descriptor = s.serializer_1.get_descriptor_wjt6a0_k$();
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.toTypedArray' call
            var this_0 = this.get_options_jecmyz_k$().get_c1px32_k$(index_0).alternativeNames_1;
            var tmp$ret$15 = copyToArray(this_0);
            var tmp$ret$13 = new (JsonNames())(tmp$ret$15.slice());
            var tmp2_annotations = plus(listOfNotNull(tmp$ret$13), s.annotations_1);
            $this$buildClassSerialDescriptor.element_om879h_k$(tmp0_elementName, tmp1_descriptor, tmp2_annotations, true);
          }
          return Unit_instance;
        }));
      }
      get_options_jecmyz_k$() {
        var tmp0 = this.options$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('options', 1, tmp, MySealedClassSerializer$_get_options_$ref_rhb6tc(), null);
        return tmp0.get_value_j01efc_k$();
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        if (decoder instanceof DefaultDecoder())
          return default_0(first(this.get_options_jecmyz_k$()).serializer_1);
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.descriptor_1;
        var composite = decoder.beginStructure_yljocp_k$(descriptor);
        var index = composite.decodeElementIndex_bstkhp_k$(this.descriptor_1);
        if (index === -1) {
          throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Single key expected, but received none.');
        }
        if (index === -3)
          throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Unknown key received.');
        var serializer = this.get_options_jecmyz_k$().get_c1px32_k$(index).serializer_1;
        var tmp;
        if (equals(serializer.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), OBJECT_getInstance())) {
          composite.decodeBooleanElement_vuyhtj_k$(this.descriptor_1, index);
          tmp = default_0(serializer);
        } else {
          tmp = composite.decodeSerializableElement$default_j0zaoi_k$(this.descriptor_1, index, serializer);
        }
        var result = tmp;
        if (!(composite.decodeElementIndex_bstkhp_k$(this.descriptor_1) === -1))
          throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Single key expected, but received multiple.');
        var result_0 = result;
        composite.endStructure_1xqz0n_k$(descriptor);
        return result_0;
      }
      serialize_kj9hv3_k$(encoder, value) {
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.descriptor_1;
        var composite = encoder.beginStructure_yljocp_k$(descriptor);
        var index = getIndex(this, value);
        var tmp = this.get_options_jecmyz_k$().get_c1px32_k$(index).serializer_1;
        var serializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
        if (equals(serializer.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), OBJECT_getInstance())) {
          composite.encodeBooleanElement_ydht7q_k$(this.descriptor_1, index, true);
        } else {
          composite.encodeSerializableElement_isqxcl_k$(this.descriptor_1, index, serializer, value);
        }
        composite.endStructure_1xqz0n_k$(descriptor);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_kj9hv3_k$(encoder, !(value == null) ? value : THROW_CCE());
      }
    }
    protoOf($).get_default_qtagd4_k$ = get_default;
    initMetadataForClass($, 'MySealedClassSerializer', VOID, VOID, [MySealedClassSerializerInterface()]);
    MySealedClassSerializerClass = $;
  }
  return MySealedClassSerializerClass;
}
function get_default() {
  return default_0(first(this.get_options_jecmyz_k$()).serializer_1);
}
var MySealedClassSerializerInterfaceClass;
function MySealedClassSerializerInterface() {
  if (MySealedClassSerializerInterfaceClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MySealedClassSerializerInterface', VOID, VOID, [KSerializerWithDefault()]);
    MySealedClassSerializerInterfaceClass = $;
  }
  return MySealedClassSerializerInterfaceClass;
}
//region block: exports
export {
  Option as Option33wwe88i3c121,
  MySealedClassSerializerInterface as MySealedClassSerializerInterface1lg9fzm3qtbhk,
  MySealedClassSerializer as MySealedClassSerializerpklrcjai1fw6,
};
//endregion

//# sourceMappingURL=MySealedClassSerializer.mjs.map
